/**
 * Alpine component for the participant answer submit button.
 *
 * When online:  delegates to `$wire.submitAnswer()` (Livewire handles everything).
 * When offline: intercepts the submit, builds the JSON body from Livewire state,
 *               calls `offlineQueue.submitOrQueue()` on the layout body component,
 *               and shows a local "saved offline" message without touching Livewire.
 *
 * Usage (in join.blade.php):
 *   x-data="participantAnswer({ sessionCode, anonymousToken, liveSessionQuestionId })"
 */
export default function participantAnswer({ sessionCode, anonymousToken, liveSessionQuestionId }) {
    return {
        sessionCode,
        anonymousToken,
        liveSessionQuestionId,
        pendingThisQuestion: false,

        async handleSubmit($wire) {
            // Online path — let Livewire own the full submit flow as before.
            if (navigator.onLine) {
                $wire.submitAnswer();
                return;
            }

            // Offline path — enqueue via offlineQueue on <body>.
            const body = {
                live_session_question_id: this.liveSessionQuestionId,
                anonymous_token: this.anonymousToken,
                option_ids: Array.isArray($wire.selectedOptionIds) ? [...$wire.selectedOptionIds] : [],
                text: $wire.textAnswer ?? undefined,
                numeric_value: $wire.numericValue ?? undefined,
                idempotency_key: crypto.randomUUID(),
            };

            // Remove undefined keys so JSON.stringify omits them.
            Object.keys(body).forEach(k => body[k] === undefined && delete body[k]);

            const queue = Alpine.$data(document.body);
            await queue.submitOrQueue({ sessionCode: this.sessionCode, body });

            this.pendingThisQuestion = true;
        },
    };
}
